<template>
  <v-card>
    <v-card-title class="pb-0">
      <h1 class="headline">
        Загрузка клиентов
      </h1>
    </v-card-title>
    <v-card-text class="pt-2">
      <input
        id="get-file-dialog"
        type="file"
        @change="handleFiles"
      >
      <v-spacer />
      <v-btn
        color="primary"
        small
        class="my-0"
        :loading="fileLoading"
        @click="openFileOption"
      >
        Выбрать файл
      </v-btn>
    </v-card-text>
  </v-card>
</template>
<script>
import { importClientsFile } from "../../../backend/importApi.js";

export default {
  data() {
    return {
      fileLoading: false,
    };
  },
  methods: {
    openFileOption() {
      var inputElement = document.getElementById("get-file-dialog");
      inputElement.click();
    },
    handleFiles(ev) {
      this.fileLoading = true;
      const file = ev.target.files[0];

      const reader = new FileReader();

      reader.onload = e => {
        var arrayBuffer = e.target.result;
        var array = Array.from(new Uint8Array(arrayBuffer));

        this.import({ originName: file.name, data: array, type: 1 });
      };
      if (file) {
        reader.readAsArrayBuffer(file);
      } else {
        this.fileLoading = false;
      }
    },
    async import(fileInfo) {
      await importClientsFile(fileInfo);
      this.$router.push({ name: "clients" });
      this.fileLoading = false;
    },
  },
};
</script>

<style>
#get-file-dialog {
  display: none;
}
</style>
